import { render, staticRenderFns } from "./ShiftUtilisationFigure.vue?vue&type=template&id=c87a1890&scoped=true&"
import script from "./ShiftUtilisationFigure.vue?vue&type=script&lang=ts&"
export * from "./ShiftUtilisationFigure.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftUtilisationFigure.vue?vue&type=style&index=0&id=c87a1890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87a1890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VChip,VIcon,VTooltip})
